// import { transformToProcedurePayload } from 'clickNgo/helpers/api'
// import { callProcedure } from 'core/classes/helpers/callProcedure'

interface IApplyPlanningWizardFlags {
  partnerId: string
  isHideWizard: boolean
}

/**
 * TODO: SP Not implemented yet
 */
export const applyPlanningWizardFlags = async ({
  partnerId,
  isHideWizard,
}: IApplyPlanningWizardFlags): Promise<any> => {
  // TODO: Uncomment after API integration
  // const response = await callProcedure('spJBPPlanningWizardFlagsApply', {
  //   data: transformToProcedurePayload({
  //     PartnerId: partnerId,
  //     HidePlanningWizard: Number(isHideWizard),
  //   }),
  // })

  // if (response.error) {
  //   throw new Error('Error on apply Planning Wizard Flags')
  // }

  // return response

  // TODO: Remove after API integration
  return null
}
